import { Form } from "@/organisms/Form"
import { usePolicyPage } from "../hooks/usePolicyPage"

import type { PolicyPageProps } from "./PolicyForm.types"

export const PolicyPageFallback = (props: Pick<PolicyPageProps, "type">) => {
  const nextProps = usePolicyPage(props)

  return <Form.Fallback {...nextProps} />
}
